(() => {
    'use strict';

    angular
        .module('cog.shared')
        .service('horseData', horseData);

    /* @ngInject */
    function horseData() {

        function getTrackName(trackCode:string) {
            var track = "";
            switch(trackCode){
                case 'AQU':
                    track = "Aqueduct";
                    break;
                case 'BEL':
                    track = "Belmont Park";
                    break;
                case 'BEU':
                    track = "Beulah Park";
                    break;
                case 'BAY':
                    track = "Bay Meadows";
                    break;
                case 'BAL':
                    track = "Balmoral Park";
                    break;
                case 'CHU':
                    track = "Churchill Downs";
                    break;
                case 'CRC':
                    track = "Calder Race Course";
                    break;
                case 'CTN':
                    track = "Charles Town";
                    break;
                case 'DED':
                    track = "Delta Downs";
                    break;
                case 'DEL':
                    track = "Delaware Park";
                    break;
                case 'DMR':
                    track = "Del Mar";
                    break;
                case 'ELP':
                    track = "Ellis Park";
                    break;
                case 'EMD':
                    track = "Emerald Downs";
                    break;
                case 'EVD':
                    track = "Evangeline Downs";
                    break;
                case 'FGX':
                    track = "Fairgrounds";
                    break;
                case 'FLK':
                    track = "Finger Lakes";
                    break;
                case 'FPK':
                    track = "Fairplex Park";
                    break;
                case 'GOL':
                    track = "Golden Gate Fields";
                    break;
                case 'GLD':
                    track = "Great Lakes Downs";
                    break;
                case 'GUL':
                    track = "Gulfstream";
                    break;
                case 'HOL':
                    track = "Hollywood Park";
                    break;
                case 'HOS':
                    track = "Hoosier Park";
                    break;
                case 'SAM':
                    track = "Sam Houston Race Park";
                    break;
                case 'KEN':
                    track = "Keeneland";
                    break;
                case 'LOS':
                    track = "Los Alamitos";
                    break;
                case 'LAU':
                    track = "Laurel Park";
                    break;
                case 'LON':
                    track = "Lone Star Park";
                    break;
                case 'MED':
                    track = "Meadowlands";
                    break;
                case 'MNR':
                    track = "Mountaineer Park";
                    break;
                case 'OAK':
                    track = "Oaklawn Park";
                    break;
                case 'PEN':
                    track = "Penn National";
                    break;                    
                case 'PHA':
                    track = "Philadelphia Park";
                    break;
                case 'PIM':
                    track = "Pimlico";
                    break;
                case 'POM':
                    track = "Pompano Park";
                    break;
                case 'RET':
                    track = "Retama Park";
                    break;
                case 'REM':
                    track = "Remington Park";
                    break;
                case 'SAX':
                    track = "Santa Anita Park";
                    break;
                case 'SAR':
                    track = "Saratoga";
                    break;
                case 'SUF':
                    track = "Suffolk Downs";
                    break;
                case 'TAM':
                    track = "Tampa Bay Downs";
                    break;
                case 'THI':
                    track = "Thistledown";
                    break;
                case 'TUR':
                    track = "Turfway Park";
                    break;
                case 'TUP':
                    track = "Turf Paradise";
                    break;
                case 'FHD':
                    track = "Freehold Raceway";
                    break;
                case 'DOV':
                    track = "Dover Downs";
                    break;
                case 'MNC':
                    track = "Monticello Raceway";
                    break;
                case 'CEX':
                    track = "Cal Expo";
                    break;
                case 'MOW':
                    track = "Mohawk Raceway";
                    break;
                case 'MEA':
                    track = "Meadows";
                    break;
                case 'YON':
                    track = "Yonkers Raceway";
                    break;
                case 'PBM':
                    track = "Palm Beach Mat";
                    break;
                case 'PHX':
                    track = "Phoenix Greyhound";
                    break;
                case 'GGH':
                    track = "Gulf Greyhound";
                    break;
                case 'DER':
                    track = "Derby Lane Matinee";
                    break;
                case 'NFD':
                    track = "Northfield Park";
                    break;
                case 'POC':
                    track = "Pocono Downs";
                    break;
                case 'DLN':
                    track = "Derby Lane Evening";
                    break;
                case 'PBN':
                    track = "Palm Beach Eve";
                    break;
                case 'WOX':
                    track = "Woodbine";
                    break;
                case 'MAY':
                    track = "Maywood Park";
                    break;
                case 'CNL':
                    track = "Colonial Downs";
                    break;
                case 'HAR':
                    track = "Harrington Raceway";
                    break;
                case 'PRM':
                    track = "Prairie Meadows";
                    break;
                case 'ARL':
                    track = "Arlington Park";
                    break;
                case 'MTH':
                    track = "Monmouth";
                    break;
                case 'HAW':
                    track = "Hawthorne";
                    break;
                case 'SUN':
                    track = "Sunland Park";
                    break;
                case 'CBY':
                    track = "Canterbury Park";
                    break;
                case 'MDL':
                    track = "Meadowlands Harness";
                    break;
                case 'RVD':
                    track = "River Downs";
                    break;
                case 'WOH':
                    track = "Woodbine Harness";
                    break;                    
                case 'RED':
                    track = "Red Mile";
                    break;
                case 'PQI':
                    track = "Presque Isle Downs";
                    break;
                case 'DUB':
                    track = "Dubai Racing";
                    break;
                case 'PLN':
                    track = "Pleasanton Race Track";
                    break;
                case 'SOL':
                    track = "Solano Race Track";
                    break;
                case 'STK':
                    track = "Stockton Race Track";
                    break;
                case 'STR':
                    track = "Santa Rosa Race Track";
                    break;
                case 'FNO':
                    track = "Fresno Race Track";
                    break;
                case 'SGH':
                    track = "Saratoga Harness";
                    break;
                case 'KDD':
                    track = "Kentucky Derby";
                    break;
                case 'SCR':
                    track = "Sacramento";
                    break;
                case 'TIM':
                    track = "Timonium";
                    break;
                case 'KED':
                    track = "Kentucky Downs";
                    break;
                case 'IND':
                    track = "Indiana Downs";
                    break;
                case 'RUI':
                    track = "Ruidoso Downs";
                    break;
                case 'IDH':
                    track = "Indiana Downs Harness";
                    break;
                case 'OKD':
                    track = "Kentucky Oaks Daily Double";
                    break;
                case 'PDD':
                    track = "The Preakness Double";
                    break;
                case 'CHE':
                    track = "Chester Downs";
                    break;
                case 'LOT':
                    track = "Los Alamitos - Thoroughbred";
                    break;
                case 'DWC':
                    track = "Dubai World Cup";
                    break;
                case 'GSW':
                    track = "Gulfstream Park West";
                    break;
                case 'HAH':
                    track = "Hawthorne Harness";
                    break;
                case 'PRD':
                    track = "Plainridge Park";
                    break;
                case 'JDN':
                    track = "Jacksonville Evening";
                    break;
                case 'JDM':
                    track = "Jacksonville Matinee";
                    break;
                case 'WDE':
                    track = "Wheeling Down Evening";
                    break;
                case 'WDM':
                    track = "Wheeling Downs Matinee";
                    break;
                case 'HPH':
                    track = "Harrahs Philadelphia";
                    break;
                case 'SCI':
                    track = "Scioto Downs";
                    break;
                case 'MVR':
                    track = "Mahoning Valley";
                    break;
                default:
                    track = trackCode;
            }
            return track;
        }

        function getBetType(betCode:string) {
            var betType = "";
            switch(betCode){
                case 'WIN':
                    betType = "WIN";
                    break;
                case 'PLC':
                    betType = "PLACE";
                    break;
                case 'SHW':
                    betType = "SHOW";
                    break;
                case 'WPS':
                    betType = "WIN/PLACE/SHOW";
                    break;
                case 'WP':
                    betType = "WIN/PLACE";
                    break;
                case 'WS':
                    betType = "WIN/SHOW";
                    break;
                case 'PS':
                    betType = "PLACE/SHOW";
                    break;
                case 'DDB':
                    betType = "DOUBLE";
                    break;
                case 'EXA':
                    betType = "EXACTA";
                    break;
                case 'TRI':
                    betType = "TRIFECTA";
                    break;
                case 'QIN':
                    betType = "QUINELLA";
                    break;
                case 'QBX':
                    betType = "QUINELLA BOX";
                    break;
                case 'SPR':
                    betType = "SUPERFECTA";
                    break;
                case 'EXX':
                    betType = "EXACTA BOX";
                    break;
                case 'TRX':
                    betType = "TRIFECTA BOX";
                    break;
                case 'PK3':
                    betType = "PICK-3";
                    break;
                case 'PK4':
                    betType = "PICK-4";
                    break;
                case 'PK6':
                    betType = "PICK-6";
                    break;
                case 'SPX':
                    betType = "SUPERFECTA BOX";
                    break;
                case 'WPY':
					betType = "WIN PARLAY";
                    break;
				case 'PPY':
					betType = "PLC PARLAY";
                    break;
				case 'SPY':
					betType = "SHW PARLAY";                    
					break;
				case 'WRR':
                    betType = "WIN RR";
                    break;
                case 'PRR':
                    betType = "PLC RR";
                    break;
                case 'SRR':
                    betType = "SHW RR";
                    break;
                case 'HQ':
                    betType = "HOUSE QIN";
                    break;
                case 'HQX':
                    betType = "HOUSE QIN BOX";
                    break;
                default:
                    betType = betCode;
            }
            return betType;
        }

        var service: IHorseTrack = {
            getTrackName: (trackCode) => {
                return getTrackName(trackCode);
            },
            getBetType: (betCode) => {
                return getBetType(betCode);
            }
        };
        return service;
    }
})();